module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-8-4b0d2fda3bd558caf3504bdab06624f1.jpg";